import { defineComponent } from 'vue';
export default defineComponent({
    props: {
        text: {
            type: String,
            default: '暂无内容，探索一下其他内容吧~'
        },
        type: {
            type: String,
            default: ''
        }
    }
});
